import { object, collection, number, boolean } from '@gogame/schemas';

const widgetSchema = object({
  id: number(),
  collapsed: boolean(),
});

const widgetRow = collection(widgetSchema).default([]);

export const widgetsSchema = collection(widgetRow)
  .encodeSeparator('_~')
  .default([]);
